import { buildGaTransportGuardScript } from "@/lib/analytics/gaTransport";

export type ConsentModeState = "granted" | "denied";

export type ConsentModeInput = {
  analytics: ConsentModeState;
  marketing: ConsentModeState;
};

export type ConsentModeV2State = {
  analytics_storage: ConsentModeState;
  ad_storage: ConsentModeState;
  ad_user_data: ConsentModeState;
  ad_personalization: ConsentModeState;
  functionality_storage: "granted";
  security_storage: "granted";
};

export const CROSS_DOMAIN_LINKER_DOMAINS = ["singingattitude.com", "singingattitude.uk"] as const;

export const DEFAULT_CONSENT_MODE_INPUT: ConsentModeInput = {
  analytics: "denied",
  marketing: "denied",
};

export function buildConsentModeState(consent: ConsentModeInput): ConsentModeV2State {
  return {
    analytics_storage: consent.analytics,
    ad_storage: consent.marketing,
    ad_user_data: consent.marketing,
    ad_personalization: consent.marketing,
    functionality_storage: "granted",
    security_storage: "granted",
  };
}

export function normalizeGtmContainerId(value: string | undefined | null): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  return /^GTM-[A-Z0-9]+$/i.test(trimmed) ? trimmed.toUpperCase() : null;
}

export const UK_GA_MEASUREMENT_ID = "G-PSP8GLX051";
const UK_GA_DISABLE_KEY = "ga-disable-G-PSP8GLX051";

declare global {
  interface Window {
    "ga-disable-G-PSP8GLX051"?: boolean;
    __saStopGaTransports?: () => void;
  }
}

// Consent Mode can leave an already-loaded GA runtime sending cookieless pings.
// Apply Google's destination opt-out before the consent command or UI event.
export function syncGoogleAnalyticsCollection(analyticsGranted: boolean) {
  if (typeof window !== "undefined") {
    window[UK_GA_DISABLE_KEY] = analyticsGranted !== true;
    if (!analyticsGranted) window.__saStopGaTransports?.();
  }
}

export function buildEarlyConsentModeScript() {
  return `
  window[${JSON.stringify(UK_GA_DISABLE_KEY)}] = true;
  ${buildGaTransportGuardScript()}
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function(){window.dataLayer.push(arguments);};
  window.gtag('consent', 'default', ${JSON.stringify({
    ...buildConsentModeState({ analytics: "denied", marketing: "denied" }),
    wait_for_update: 500,
  })});
  window.gtag('set', 'linker', ${JSON.stringify({
    domains: [],
    accept_incoming: false,
    decorate_forms: false,
    url_passthrough: false,
  })});
`;
}
